import { ApiContract, HttpMethods } from '@tc/http';
import { Api } from '../../configuration/Api';

/**
 * Contract for retrieving saved searches.
 */
@ApiContract({ endpoint: Api.findSavedSearches, httpMethod: HttpMethods.get })
export class ApiGetSavedSearches {
  constructor() {}
}
